import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import success from "assets/images/success.png";
import warning from "assets/images/warning.png";
import failed from "assets/images/failed.png";
import { hideNotificationDialogManualPOUpload } from "redux/actions/notificationManualPOUploadAction";
import { useEffect } from "react";
import { resetUploadPurchaseOrder } from "redux/actions/uploadManualPoAction";
import { PAGE } from "./CONSTANTS";

export default function AlertDialogManualPOUpload({
  onConfirmUpload,
  isuploadManualPoResponse,
  isuploadManualPoError,
  onReviewUpload,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isShowing,
    title,
    content,
    buttonLabel1,
    buttonLabel2,
    showSecondDialog,
    showButton1,
    showButton2
  } = useSelector((state) => state.notoficationManualPOUpload);

  const handleClose = (event, reason) => {
    event.preventDefault();
    dispatch(hideNotificationDialogManualPOUpload());
    navigate(PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url);
    dispatch(resetUploadPurchaseOrder());
  };

  const handleConfirm = async () => {
    dispatch(hideNotificationDialogManualPOUpload());
    await onConfirmUpload();
    dispatch(hideNotificationDialogManualPOUpload());
  };

  if (isuploadManualPoError) {
    dispatch(hideNotificationDialogManualPOUpload());
  }

  useEffect(() => {
    if (isuploadManualPoResponse?.status === "review") {
      localStorage.setItem('jobId', isuploadManualPoResponse?.jobId);
      navigate(PAGE.PO_SUMMARY.url, {
        state: {
          retainSearchCriteria: true,
        }
      });
    }
    if (isuploadManualPoResponse?.status === "confirmed") {
      dispatch({
        type: "SHOW_SECOND_DIALOG",
        payload: {
          title: "PO Confirmation",
          content: isuploadManualPoResponse.createdPoCount < 2 ? `${isuploadManualPoResponse.createdPoCount} PO have been successfully confirmed` :
            `${isuploadManualPoResponse.createdPoCount} PO's have been successfully confirmed`,
        },
      });
    }
  }, [dispatch, isuploadManualPoResponse, isuploadManualPoError, navigate]);

  const handleReview = async () => {
    dispatch(hideNotificationDialogManualPOUpload());
    await onReviewUpload();
    dispatch(hideNotificationDialogManualPOUpload());
    dispatch(hideNotificationDialogManualPOUpload());
  };
  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={isShowing}
        onClose={handleClose}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <DialogTitle id="title" sx={{ fontWeight: "bold" }}>
          {title.includes("Status") ? (
            <img
              style={{
                height: "25px",
                color: "#108810",
                marginRight: "12px",
                paddingTop: "8px",
              }}
              src={warning}
              alt="warning"
            />
          ) : title.includes("Successful") ? (
            <img
              style={{
                height: "25px",
                color: "#108810",
                marginRight: "12px",
                paddingTop: "8px",
              }}
              src={success}
              alt="success"
            />
          ) : title.includes("Failed") ? (
            <img
              style={{
                height: "25px",
                color: "#108810",
                marginRight: "12px",
                paddingTop: "8px",
              }}
              src={failed}
              alt="failed"
            />
          ) : (
            ""
          )}
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="description">{content}</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ pl: 3, pb: 3, justifyContent: "flex-start" }}>
          {(showButton1 && <Button variant="contained" color="primary" onClick={handleConfirm}>
            {buttonLabel1}
          </Button>)}
          {(showButton2 && <Button variant="contained" color="secondary" onClick={handleReview}>
            {buttonLabel2}
          </Button>)}
        </DialogActions>
      </Dialog>

      {showSecondDialog && (
        <Dialog
          open={showSecondDialog}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            {title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>{content}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={handleClose}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
